// tslint:disable
export var ContactTimePreferenceType;
(function (ContactTimePreferenceType) {
    // UNKN
    ContactTimePreferenceType[ContactTimePreferenceType["UNKNOWN"] = 0] = "UNKNOWN";
    // TM
    ContactTimePreferenceType[ContactTimePreferenceType["TIMEOFTHEDAY"] = 1] = "TIMEOFTHEDAY";
    // BTWTM
    ContactTimePreferenceType[ContactTimePreferenceType["BETWEENTIMES"] = 2] = "BETWEENTIMES";
    // ANYTM
    ContactTimePreferenceType[ContactTimePreferenceType["ANYTIME"] = 3] = "ANYTIME";
    // BUSHR
    ContactTimePreferenceType[ContactTimePreferenceType["BUSINESSHOURS"] = 4] = "BUSINESSHOURS";
    // EVNTM
    ContactTimePreferenceType[ContactTimePreferenceType["EVENINGTIMES"] = 5] = "EVENINGTIMES";
})(ContactTimePreferenceType || (ContactTimePreferenceType = {}));
//# sourceMappingURL=ContactTimePreferenceType.js.map